module.exports = __webpack_public_path__ + "static/img/Tube.020350b4.jpg";